<!--
BEDROCK Core
Copyright (c) 2026 Patrick Schimmelpfennig

All rights reserved.

Unauthorized copying, modification, distribution or use of this software,
in whole or in part, is strictly prohibited without explicit written permission
from the author or an authorized BEDROCK license grant.
-->



<template>

    <SidebarOverlay v-if="open" @click="emitClose" />

    <aside class="sdev-sidebar" :class="{
        'is-open': open,
        'is-collapsed': !open
    }">
        <SidebarRuntime />
        <SidebarNavigation :collapsed="!open" />

    </aside>

</template>

<script setup>

import SidebarNavigation from "./SidebarNavigation.vue"
import SidebarOverlay from "./SidebarOverlay.vue"
import SidebarRuntime from "./SidebarRuntime.vue"

const props = defineProps({
    open: Boolean
})

const emit = defineEmits(["close"])

function emitClose() {
    emit("close")
}

</script>